import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-regular-svg-icons";
import logo from "../assets/images/logo.png";
import SignupModal from "./Signup";
import ListProperty from "./ListProperty";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const [isSignupOpen, setSignupOpen] = useState(false);
  const [isListOpen, setListOpen] = useState(false);
  const handleClickopen = () => {
    setSignupOpen(true);
  };
  const handleClick = () => {
    setListOpen(true);
  };
  const navigate = useNavigate();
  return (
    <>
      <header className="flex justify-between items-center h-25 px-6 bg-white shadow-md">
        <button onClick={() => navigate("/")} className="focus:outline-none">
          <img
            src={logo}
            alt="zoy logo"
            className="h-24 w-auto object-contain"
          />
        </button>
        {/* Keeps logo large without increasing header */}
        <nav className="space-x-4 flex items-center">
          <button
            className="text-sm font-medium text-black hover:text-gray-600"
            onClick={handleClick}
          >
            List Your Property
          </button>
          <button
            onClick={handleClickopen}
            className="flex items-center text-sm font-medium text-black border border-black px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors"
          >
            <FontAwesomeIcon icon={faUser} className="mr-2 text-sm" /> Sign Up
          </button>
        </nav>
      </header>
      <SignupModal isOpen={isSignupOpen} onClose={() => setSignupOpen(false)} />
      <ListProperty isOpen={isListOpen} onClose={() => setListOpen(false)} />
    </>
  );
};

export default Header;
